
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import ReadMoreButton from "./ReadMoreButton";

interface EntryTextProps {
  isTranslating: boolean;
  finalDisplayText: string;
  finalDisplayPreviewText: string;
  expanded: boolean;
  toggleExpand: () => void;
}

const EntryText = ({
  isTranslating,
  finalDisplayText,
  finalDisplayPreviewText,
  expanded,
  toggleExpand
}: EntryTextProps) => {
  const { language } = useLanguage();
  
  return (
    <div className="whitespace-pre-line text-sm md:text-base leading-relaxed">
      {isTranslating ? (
        <div className="flex items-center justify-center py-4 text-muted-foreground">
          <span className="animate-pulse">{t('common.translating', language)}</span>
        </div>
      ) : (
        <>
          {expanded ? finalDisplayText : finalDisplayPreviewText}
          
          {(finalDisplayText.length > 150) && (
            <ReadMoreButton expanded={expanded} toggleExpand={toggleExpand} />
          )}
        </>
      )}
    </div>
  );
};

export default EntryText;
